import { render, staticRenderFns } from "./EngagementCard.vue?vue&type=template&id=315556c7"
import script from "./EngagementCard.vue?vue&type=script&lang=js"
export * from "./EngagementCard.vue?vue&type=script&lang=js"
import style0 from "./EngagementCard.vue?vue&type=style&index=0&id=315556c7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports